module.exports = __webpack_public_path__ + "media/images/country_flags/gh-36f20c56c9a448047fd404c9fbda5888.png";